import Flex from "../../../../../../../../../../components/Flex";
import { useReduceDisclosure } from "../../../../../../../../../../hooks/use-reduce-disclosure";
import { StyleAddButton } from "../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import UpsertAllergiesDrawer from "../../../../allergy/UpsertAllergiesDrawer";
import UpsertFamilyHistory from "../../../../history/UpsertFamilyHistory";
import UpsertMedicalHistoryDrawer from "../../../../history/UpsertMedicalHistoryDrawer";
import UpsertSurgicalHistoryDrawer from "../../../../history/UpsertSurgicalHistoryDrawer";
import EncounterSocialHistoryModal from "../../../../history/social-history/EncounterSocialHistoryModal";
import UpsertMedicationsDrawer from "../../../../medication/UpsertMedicationsDrawer";

/**
 * @description
 * - This component is used to add allergy, pmh, psh, fh, sh, current meds
 * - It uses the useReduceDisclosure hook to manage the disclosure of the drawers
 * - It uses the StyleAddButton component to add the buttons
 * - It uses the UpsertAllergiesDrawer component to add the allergies
 * - It uses the UpsertMedicalHistoryDrawer component to add the medical history
 * - It uses the UpsertSurgicalHistoryDrawer component to add the surgical history
 * - It uses the UpsertFamilyHistory component to add the family history
 * - It uses the UpsertMedicationsDrawer component to add the medications
 * @returns add allergy, pmh, psh, fh, sh, current meds
 *
 *
 * @author [Rajkumar Rathod]
 */
const ClinicalActions = () => {
  const [
    allergyDisclosure,
    medicalHistoryDisclosure,
    surgicalHistoryDisclosure,
    familyHistoryDisclosure,
    medicationDisclosure,
    socialHistoryDisclosure,
  ] = useReduceDisclosure(6);

  return (
    <>
      <Flex gap={1} flexWrap="wrap" sx={{ my: 1 }}>
        {[
          { label: "Add Allergy", disc: allergyDisclosure, w: "120px" },
          { label: "Add PMH", disc: medicalHistoryDisclosure, w: "100px" },
          { label: "Add PSH", disc: surgicalHistoryDisclosure, w: "100px" },
          { label: "Add FH", disc: familyHistoryDisclosure, w: "100px" },
          { label: "Add SH", disc: socialHistoryDisclosure, w: "100px" },
          {
            label: "Add Current Meds",
            disc: medicationDisclosure,
            w: "120px",
          },
        ].map((item) => {
          return (
            <StyleAddButton
              key={item.label}
              w={item.w}
              onClick={() => item.disc.open()}
              label={item.label}
            />
          );
        })}
      </Flex>
      <UpsertAllergiesDrawer disclosureHost={allergyDisclosure} />
      <UpsertMedicalHistoryDrawer disclosureHost={medicalHistoryDisclosure} />
      <UpsertSurgicalHistoryDrawer disclosureHost={surgicalHistoryDisclosure} />
      <UpsertFamilyHistory disclosureHost={familyHistoryDisclosure} />
      <UpsertMedicationsDrawer disclosureHost={medicationDisclosure} />
      <EncounterSocialHistoryModal disclosureHost={socialHistoryDisclosure} />
    </>
  );
};

export default ClinicalActions;
